<template>
  <div>
    <div class="fip-header-buttons">
      <watch-download
        v-if="showWatchDownload"
        :item="item"
        :order-info="orderInfo" />
      <rent-buy
        v-if="showRentBuy"
        :definitions-by-quality="definitionsByQuality"
        :selected-quality="selectedQuality"
        :item="item"
        :is-playing="isPlaying"
        :can-be-bookmarked="canBeBookmarked"
        @select-quality="onSwitchQuality"
        @buy-rent="onClickButtonBuyOrRent" />
      <alert-button
        v-if="isProspect"
        :alert="alert"
        :video="itemLight" />
    </div>
    <div
      v-if="showRentBuy && !hasTicketVideo && !isProspect"
      class="area-input-coupon">
      <coupon-input
        :discounted-definition="discountedDefinition || {}"
        :banner-definition="bannerDefinition" />
    </div>
  </div>
</template>

<script>
import _find from 'lodash/find'
import { mapGetters } from 'vuex'
import CouponInput from '../couponInput/CouponInput.vue'
import RentBuy from '../rentBuy/RentBuy.vue'
import WatchDownload from '../watchDownload/WatchDownload'
import AlertButton from '../alertButton/AlertButton'
import apiConstants from '../../../../../api.constants'
export default {
  name: 'FipHeaderActions',
  components: {
    CouponInput,
    RentBuy,
    WatchDownload,
    AlertButton
  },
  props: {
    alert: {
      type: Object,
      required: true
    },
    item: {
      type: Object,
      required: true
    },
    seasons: {
      type: Array,
      required: true
    },
    orderInfo: {
      type: Object,
      required: true
    },
    hasTicketVideo: {
      type: Boolean,
      default: false
    },
    isProspect: {
      type: Boolean,
      default: false
    },
    definitionsByQuality: {
      type: Object,
      required: true
    },
    selectedQuality: {
      type: String,
      required: true
    },
    bannerDefinition: {
      type: Object,
      required: true
    },
    isPlaying: {
      type: Boolean,
      default: false
    },
    canBeBookmarked: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    ...mapGetters({
      activatedCoupon: 'user/getActivatedCoupon',
      getBookmarkById: 'bookmarks/getBookmarkById'
    }),
    isPack () {
      return this.item.type === apiConstants.RESOURCE_TYPES.PACKAGE
    },
    isSeason () {
      return this.seasons.length !== 0
    },
    showSeasonDropdown () {
      return this.isSeason && this.seasons.length > 1
    },
    showWatchDownload () {
      return (this.hasTicketVideo && !this.isSeason && !this.isPack) || !!this.item.freeContent
    },
    showRentBuy () {
      return (
        !this.item.freeContent &&
        ((this.isSeason && !this.item.episodes.every(episode => episode.orderInfo)) ||
        (this.isPack && this.item.videos.some(video => !video.orderInfo)) ||
        !this.hasTicketVideo)
      )
    },
    discountedDefinition () {
      return _find(this.definitionsByQuality[this.selectedQuality], definition => definition.hasDiscount)
    },
    seasonsForSelection () {
      return this.seasons.map(({ seasonNumber, id, title }) => ({
        text: `${this.$t('season.season')} ${('0' + seasonNumber).slice(-2)}`,
        id,
        title
      }))
    },
    currentSeason () {
      return this.seasonsForSelection.find(season => season.id === this.item.id)
    },
    itemLight () {
      return {
        id: this.item.id,
        type: this.item.type,
        videoType: this.item.videoType,
        title: this.item.title
      }
    }
  },
  methods: {
    onSwitchQuality (quality) {
      this.$emit('on-switch-quality', quality)
    },
    onClickButtonBuyOrRent (definition) {
      this.$emit('on-buy-rent', definition)
    }
  }
}
</script>
<style lang="scss" scoped>
.fip-header-buttons {
  flex-shrink: 0;
  @include mediaQueries('display', (medium: flex, xlarge: inline-flex));
  @include mediaQueries('padding-bottom', (xsmall: 20px));
  @include mediaQueries('width', (xsmall: 100%, xlarge: auto));
  @include mediaQueries('margin-top', (xsmall: 10px));

  &:not(:last-child) {
    @include mediaQueries('margin-right', (small: 30px));
  }

}
.area-input-coupon {
  @include mediaQueries('width', (xsmall: 100%, small: auto));
  @include mediaQueries('margin-bottom', (xsmall: 20px));
  @include mediaQueries('padding-bottom', (large: 20px));
  @include mediaQueries('margin-top', (xsmall: 15px, large: 10px));
}
</style>
